"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ConsentHowFields.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _consent = require('shared/services/consent');

var _Form = require('web/components/Form');



















const HowOption = ({ name, value, label, isChecked, onPick }) => {
  const onChange = _react.useCallback.call(void 0, () => onPick(value), [onPick, value])
  return (
    _react2.default.createElement('label', { className: "consent-how-fields--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      , _react2.default.createElement('input', { type: "radio", name: name, checked: isChecked, onChange: onChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} )
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  label )
    )
  )
}

// How a contact agreed or asked again (In person / By phone / In writing)
// and when, for Record consent and Resubscribe's "asked again".
const ConsentHowFields = ({ howLabel, how, onHowChange, date, onDateChange }) => {
  const groupId = _react.useId.call(void 0, )
  const name = _react.useId.call(void 0, )
  // No future dates: a contact can't have agreed tomorrow.
  const noFuture = _react.useMemo.call(void 0, () => ({ after: new Date() }), [])
  return (
    _react2.default.createElement('div', { className: "consent-how-fields", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      , _react2.default.createElement('span', { id: groupId, className: "consent-how-fields--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}},  howLabel )
      , _react2.default.createElement('div', { role: "radiogroup", 'aria-labelledby': groupId, className: "consent-how-fields--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        ,  _consent.CONSENT_HOW_OPTIONS.map(o => (
          _react2.default.createElement(HowOption, {
            key: o.value,
            name: name,
            value: o.value,
            label: o.label,
            isChecked: how === o.value,
            onPick: onHowChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
          )
        ))
      )
      , _react2.default.createElement('span', { className: "consent-how-fields--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "When?")
      , _react2.default.createElement(_Form.DateInput, {
        value: date,
        onChange: onDateChange,
        disabledDays: noFuture,
        ariaLabel: "When?",
        isRequired: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      )
    )
  )
}

exports. default = ConsentHowFields
